import api from "./index";
import UserAuthStore from "../store/userStore";
import logger from "../services/Logger";

export const getModelList = async () => {
  try {
    const { orgId } = UserAuthStore.getState();
    const response = await api({
      method: "GET",
      url: "/model/list",
      params: { org_id: orgId, user_only: true },
    });
    return { models: response.data.models }; // Ensure response is returned in expected format
  } catch (err) {
    logger.error('getModels', 'Error fetching models', { error: err.message });
    return { models: [] }; // Return an empty array on failure to prevent errors
  }
};
